import { useContext } from 'react'
import { UserPreferencesContext } from './context/user-preferences/user-preferences-context'
import {
  toDisplayTemp,
  toCelsius,
  toDisplayDelta,
  fromDisplayDelta,
  displayThreshold,
} from './temperature-utils'

export const useTemperatureUnit = () => {
  const { userPreferences } = useContext(UserPreferencesContext)
  const unit = userPreferences?.temperature_unit || '°C'

  return {
    unit,
    toDisplay: (celsius) => toDisplayTemp(celsius, unit),
    toCelsius: (val) => toCelsius(val, unit),
    toDisplayDelta: (celsius) => toDisplayDelta(celsius, unit),
    fromDisplayDelta: (val) => fromDisplayDelta(val, unit),
    displayThreshold: (celsius) => displayThreshold(celsius, unit),
  }
}
